import { createSelector } from 'reselect'

const sort = source => source
    .sort((a1, a2) => {
        const a1Name = (a1.name && a1.name.toLowerCase());
        const a2Name = (a2.name && a2.name.toLowerCase());

        if (a1Name > a2Name) return 1;
        if (a1Name < a2Name) return -1;

        if (a1.id > a2.id) return 1;
        if (a1.id < a2.id) return -1;

        return 0;
    });

const getAutomation = (automations, id) => automations.find(automation => automation.id === id);
export const makeGetAutomation = () => createSelector(getAutomation, automation => automation);

const getSortedAutomations = automations => sort(automations
    .filter(automation => !automation.removed && !automation.archived))
    .map((automation, index) => ({...automation, order: index}));
export const makeGetSortedAutomations = () => createSelector(getSortedAutomations, automations => automations);

const getSortedProjectAutomations = (automations, projectId) => sort(automations
    .filter(automation => !automation.removed && !automation.archived && automation.projectId === projectId))
    .map((automation, index) => ({...automation, order: index}));
export const makeGetSortedProjectAutomations = () => createSelector(getSortedProjectAutomations, automations => automations);
